module.exports = __webpack_public_path__ + "img/01010403.734ede5f.png";